import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API()+'klienci/';

export default {

    getKlienciPageable(page,size,nazwiskoOrPesel=null){
        return axios({
            method: 'get',
            url: Boolean(nazwiskoOrPesel)? URL + 'search?page='+page+'&size='+size+'&nazwiskoOrPesel='+nazwiskoOrPesel+'&sort=idKl,desc'
            :
                URL + 'search?page='+page+'&size='+size+'&sort=idKl,desc'
            ,
        });
    },

   /* getKlienci() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=99999',
        });
    },*/

    getKlienciBezZdjec(nazwiskoOrPesel=null){
        return axios({
            method: 'get',
            url: Boolean(nazwiskoOrPesel)? URL + 'search?page=0&size=1000&nazwiskoOrPesel='+nazwiskoOrPesel
            :
                URL + 'search?page=0&size=99999'
            ,
        });
    },

    getKlient(id) {
        return axios({
            method: 'get',
            url: URL + id,
        });
    },

    addKlient(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editKlient(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteKlient(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    getKlientKartaOdbicia(idKa){
        return axios({
            method: 'get',
            url: URL + 'karty/miesieczne/odbicia/byKarta/' + idKa,
        });
    },
}



// WEBPACK FOOTER //
// ./src/modules/klienciConfig/KlienciService.js